var _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse10, _ellipse11, _ellipse12, _ellipse13, _ellipse14, _ellipse15, _ellipse16, _ellipse17, _ellipse18, _ellipse19, _ellipse20, _ellipse21, _ellipse22, _ellipse23, _ellipse24, _ellipse25, _ellipse26, _ellipse27, _ellipse28, _ellipse29, _ellipse30, _ellipse31, _ellipse32, _ellipse33, _ellipse34, _ellipse35, _ellipse36, _ellipse37, _ellipse38, _ellipse39, _ellipse40, _ellipse41, _ellipse42, _ellipse43, _ellipse44, _ellipse45, _ellipse46, _ellipse47, _ellipse48, _ellipse49, _ellipse50, _ellipse51, _ellipse52, _ellipse53, _ellipse54, _ellipse55, _ellipse56, _ellipse57, _ellipse58, _ellipse59, _ellipse60, _ellipse61, _ellipse62, _ellipse63, _ellipse64, _ellipse65, _ellipse66, _ellipse67, _ellipse68, _ellipse69, _ellipse70, _ellipse71, _ellipse72, _ellipse73, _ellipse74, _ellipse75, _ellipse76, _ellipse77, _ellipse78, _ellipse79, _ellipse80, _ellipse81, _ellipse82, _ellipse83, _ellipse84, _ellipse85, _ellipse86, _ellipse87, _ellipse88, _ellipse89, _ellipse90, _ellipse91, _ellipse92, _ellipse93, _ellipse94, _ellipse95, _ellipse96, _ellipse97, _ellipse98, _ellipse99, _ellipse100;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 167,
    height: 163,
    viewBox: "0 0 167 163",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.63879,
    cy: 2.57293,
    rx: 2.63879,
    ry: 2.57293,
    fill: "#09066B",
    fillOpacity: 0.8
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.5826,
    cy: 2.57293,
    rx: 2.63879,
    ry: 2.57293,
    fill: "#09066B",
    fillOpacity: 0.8
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 38.5262,
    cy: 2.57293,
    rx: 2.63879,
    ry: 2.57293,
    fill: "#09066B",
    fillOpacity: 0.8
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 56.4701,
    cy: 2.57293,
    rx: 2.63879,
    ry: 2.57293,
    fill: "#09066B",
    fillOpacity: 0.8
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 74.4137,
    cy: 2.57293,
    rx: 2.63879,
    ry: 2.57293,
    fill: "#09066B",
    fillOpacity: 0.8
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.63879,
    cy: 20.0688,
    rx: 2.63879,
    ry: 2.57293,
    fill: "#09066B",
    fillOpacity: 0.8
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.5826,
    cy: 20.0688,
    rx: 2.63879,
    ry: 2.57293,
    fill: "#09066B",
    fillOpacity: 0.8
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 38.5262,
    cy: 20.0688,
    rx: 2.63879,
    ry: 2.57293,
    fill: "#09066B",
    fillOpacity: 0.8
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 56.4701,
    cy: 20.0688,
    rx: 2.63879,
    ry: 2.57293,
    fill: "#09066B",
    fillOpacity: 0.8
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 74.4137,
    cy: 20.0688,
    rx: 2.63879,
    ry: 2.57293,
    fill: "#09066B",
    fillOpacity: 0.8
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.63879,
    cy: 37.5649,
    rx: 2.63879,
    ry: 2.57293,
    fill: "#09066B",
    fillOpacity: 0.8
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.5826,
    cy: 37.5649,
    rx: 2.63879,
    ry: 2.57293,
    fill: "#09066B",
    fillOpacity: 0.8
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 38.5262,
    cy: 37.5649,
    rx: 2.63879,
    ry: 2.57293,
    fill: "#09066B",
    fillOpacity: 0.8
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 56.4701,
    cy: 37.5649,
    rx: 2.63879,
    ry: 2.57293,
    fill: "#09066B",
    fillOpacity: 0.8
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 74.4137,
    cy: 37.5649,
    rx: 2.63879,
    ry: 2.57293,
    fill: "#09066B",
    fillOpacity: 0.8
  })), _ellipse16 || (_ellipse16 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.63879,
    cy: 55.0607,
    rx: 2.63879,
    ry: 2.57293,
    fill: "#09066B",
    fillOpacity: 0.8
  })), _ellipse17 || (_ellipse17 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.5826,
    cy: 55.0607,
    rx: 2.63879,
    ry: 2.57293,
    fill: "#09066B",
    fillOpacity: 0.8
  })), _ellipse18 || (_ellipse18 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 38.5262,
    cy: 55.0607,
    rx: 2.63879,
    ry: 2.57293,
    fill: "#09066B",
    fillOpacity: 0.8
  })), _ellipse19 || (_ellipse19 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 56.4701,
    cy: 55.0607,
    rx: 2.63879,
    ry: 2.57293,
    fill: "#09066B",
    fillOpacity: 0.8
  })), _ellipse20 || (_ellipse20 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 74.4137,
    cy: 55.0607,
    rx: 2.63879,
    ry: 2.57293,
    fill: "#09066B",
    fillOpacity: 0.8
  })), _ellipse21 || (_ellipse21 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.63879,
    cy: 72.5566,
    rx: 2.63879,
    ry: 2.57293,
    fill: "#09066B",
    fillOpacity: 0.8
  })), _ellipse22 || (_ellipse22 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.5826,
    cy: 72.5566,
    rx: 2.63879,
    ry: 2.57293,
    fill: "#09066B",
    fillOpacity: 0.8
  })), _ellipse23 || (_ellipse23 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 38.5262,
    cy: 72.5566,
    rx: 2.63879,
    ry: 2.57293,
    fill: "#09066B",
    fillOpacity: 0.8
  })), _ellipse24 || (_ellipse24 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 56.4701,
    cy: 72.5566,
    rx: 2.63879,
    ry: 2.57293,
    fill: "#09066B",
    fillOpacity: 0.8
  })), _ellipse25 || (_ellipse25 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 74.4137,
    cy: 72.5566,
    rx: 2.63879,
    ry: 2.57293,
    fill: "#09066B",
    fillOpacity: 0.8
  })), _ellipse26 || (_ellipse26 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.63879,
    cy: 90.0527,
    rx: 2.63879,
    ry: 2.57293,
    fill: "#09066B",
    fillOpacity: 0.8
  })), _ellipse27 || (_ellipse27 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.5826,
    cy: 90.0527,
    rx: 2.63879,
    ry: 2.57293,
    fill: "#09066B",
    fillOpacity: 0.8
  })), _ellipse28 || (_ellipse28 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 38.5262,
    cy: 90.0527,
    rx: 2.63879,
    ry: 2.57293,
    fill: "#09066B",
    fillOpacity: 0.8
  })), _ellipse29 || (_ellipse29 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 56.4701,
    cy: 90.0527,
    rx: 2.63879,
    ry: 2.57293,
    fill: "#09066B",
    fillOpacity: 0.8
  })), _ellipse30 || (_ellipse30 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 74.4137,
    cy: 90.0527,
    rx: 2.63879,
    ry: 2.57293,
    fill: "#09066B",
    fillOpacity: 0.8
  })), _ellipse31 || (_ellipse31 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.63879,
    cy: 107.549,
    rx: 2.63879,
    ry: 2.57293,
    fill: "#09066B",
    fillOpacity: 0.8
  })), _ellipse32 || (_ellipse32 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.5826,
    cy: 107.549,
    rx: 2.63879,
    ry: 2.57293,
    fill: "#09066B",
    fillOpacity: 0.8
  })), _ellipse33 || (_ellipse33 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 38.5262,
    cy: 107.549,
    rx: 2.63879,
    ry: 2.57293,
    fill: "#09066B",
    fillOpacity: 0.8
  })), _ellipse34 || (_ellipse34 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 56.4701,
    cy: 107.549,
    rx: 2.63879,
    ry: 2.57293,
    fill: "#09066B",
    fillOpacity: 0.8
  })), _ellipse35 || (_ellipse35 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 74.4137,
    cy: 107.549,
    rx: 2.63879,
    ry: 2.57293,
    fill: "#09066B",
    fillOpacity: 0.8
  })), _ellipse36 || (_ellipse36 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.63879,
    cy: 125.045,
    rx: 2.63879,
    ry: 2.57293,
    fill: "#09066B",
    fillOpacity: 0.8
  })), _ellipse37 || (_ellipse37 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.5826,
    cy: 125.045,
    rx: 2.63879,
    ry: 2.57293,
    fill: "#09066B",
    fillOpacity: 0.8
  })), _ellipse38 || (_ellipse38 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 38.5262,
    cy: 125.045,
    rx: 2.63879,
    ry: 2.57293,
    fill: "#09066B",
    fillOpacity: 0.8
  })), _ellipse39 || (_ellipse39 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 56.4701,
    cy: 125.045,
    rx: 2.63879,
    ry: 2.57293,
    fill: "#09066B",
    fillOpacity: 0.8
  })), _ellipse40 || (_ellipse40 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 74.4137,
    cy: 125.045,
    rx: 2.63879,
    ry: 2.57293,
    fill: "#09066B",
    fillOpacity: 0.8
  })), _ellipse41 || (_ellipse41 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.63879,
    cy: 142.54,
    rx: 2.63879,
    ry: 2.57293,
    fill: "#09066B",
    fillOpacity: 0.8
  })), _ellipse42 || (_ellipse42 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.5826,
    cy: 142.54,
    rx: 2.63879,
    ry: 2.57293,
    fill: "#09066B",
    fillOpacity: 0.8
  })), _ellipse43 || (_ellipse43 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 38.5262,
    cy: 142.54,
    rx: 2.63879,
    ry: 2.57293,
    fill: "#09066B",
    fillOpacity: 0.8
  })), _ellipse44 || (_ellipse44 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 56.4701,
    cy: 142.54,
    rx: 2.63879,
    ry: 2.57293,
    fill: "#09066B",
    fillOpacity: 0.8
  })), _ellipse45 || (_ellipse45 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 74.4137,
    cy: 142.54,
    rx: 2.63879,
    ry: 2.57293,
    fill: "#09066B",
    fillOpacity: 0.8
  })), _ellipse46 || (_ellipse46 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.63879,
    cy: 160.036,
    rx: 2.63879,
    ry: 2.57293,
    fill: "#09066B",
    fillOpacity: 0.8
  })), _ellipse47 || (_ellipse47 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.5826,
    cy: 160.036,
    rx: 2.63879,
    ry: 2.57293,
    fill: "#09066B",
    fillOpacity: 0.8
  })), _ellipse48 || (_ellipse48 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 38.5262,
    cy: 160.036,
    rx: 2.63879,
    ry: 2.57293,
    fill: "#09066B",
    fillOpacity: 0.8
  })), _ellipse49 || (_ellipse49 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 56.4701,
    cy: 160.036,
    rx: 2.63879,
    ry: 2.57293,
    fill: "#09066B",
    fillOpacity: 0.8
  })), _ellipse50 || (_ellipse50 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 74.4137,
    cy: 160.036,
    rx: 2.63879,
    ry: 2.57293,
    fill: "#09066B",
    fillOpacity: 0.8
  })), _ellipse51 || (_ellipse51 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 92.3575,
    cy: 2.57293,
    rx: 2.63879,
    ry: 2.57293,
    fill: "#09066B",
    fillOpacity: 0.8
  })), _ellipse52 || (_ellipse52 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 110.301,
    cy: 2.57293,
    rx: 2.63879,
    ry: 2.57293,
    fill: "#09066B",
    fillOpacity: 0.8
  })), _ellipse53 || (_ellipse53 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 128.245,
    cy: 2.57293,
    rx: 2.63879,
    ry: 2.57293,
    fill: "#09066B",
    fillOpacity: 0.8
  })), _ellipse54 || (_ellipse54 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 146.189,
    cy: 2.57293,
    rx: 2.63879,
    ry: 2.57293,
    fill: "#09066B",
    fillOpacity: 0.8
  })), _ellipse55 || (_ellipse55 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 164.133,
    cy: 2.57293,
    rx: 2.63879,
    ry: 2.57293,
    fill: "#09066B",
    fillOpacity: 0.8
  })), _ellipse56 || (_ellipse56 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 92.3575,
    cy: 20.0688,
    rx: 2.63879,
    ry: 2.57293,
    fill: "#09066B",
    fillOpacity: 0.8
  })), _ellipse57 || (_ellipse57 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 110.301,
    cy: 20.0688,
    rx: 2.63879,
    ry: 2.57293,
    fill: "#09066B",
    fillOpacity: 0.8
  })), _ellipse58 || (_ellipse58 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 128.245,
    cy: 20.0688,
    rx: 2.63879,
    ry: 2.57293,
    fill: "#09066B",
    fillOpacity: 0.8
  })), _ellipse59 || (_ellipse59 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 146.189,
    cy: 20.0688,
    rx: 2.63879,
    ry: 2.57293,
    fill: "#09066B",
    fillOpacity: 0.8
  })), _ellipse60 || (_ellipse60 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 164.133,
    cy: 20.0688,
    rx: 2.63879,
    ry: 2.57293,
    fill: "#09066B",
    fillOpacity: 0.8
  })), _ellipse61 || (_ellipse61 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 92.3575,
    cy: 37.5649,
    rx: 2.63879,
    ry: 2.57293,
    fill: "#09066B",
    fillOpacity: 0.8
  })), _ellipse62 || (_ellipse62 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 110.301,
    cy: 37.5649,
    rx: 2.63879,
    ry: 2.57293,
    fill: "#09066B",
    fillOpacity: 0.8
  })), _ellipse63 || (_ellipse63 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 128.245,
    cy: 37.5649,
    rx: 2.63879,
    ry: 2.57293,
    fill: "#09066B",
    fillOpacity: 0.8
  })), _ellipse64 || (_ellipse64 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 146.189,
    cy: 37.5649,
    rx: 2.63879,
    ry: 2.57293,
    fill: "#09066B",
    fillOpacity: 0.8
  })), _ellipse65 || (_ellipse65 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 164.133,
    cy: 37.5649,
    rx: 2.63879,
    ry: 2.57293,
    fill: "#09066B",
    fillOpacity: 0.8
  })), _ellipse66 || (_ellipse66 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 92.3575,
    cy: 55.0607,
    rx: 2.63879,
    ry: 2.57293,
    fill: "#09066B",
    fillOpacity: 0.8
  })), _ellipse67 || (_ellipse67 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 110.301,
    cy: 55.0607,
    rx: 2.63879,
    ry: 2.57293,
    fill: "#09066B",
    fillOpacity: 0.8
  })), _ellipse68 || (_ellipse68 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 128.245,
    cy: 55.0607,
    rx: 2.63879,
    ry: 2.57293,
    fill: "#09066B",
    fillOpacity: 0.8
  })), _ellipse69 || (_ellipse69 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 146.189,
    cy: 55.0607,
    rx: 2.63879,
    ry: 2.57293,
    fill: "#09066B",
    fillOpacity: 0.8
  })), _ellipse70 || (_ellipse70 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 164.133,
    cy: 55.0607,
    rx: 2.63879,
    ry: 2.57293,
    fill: "#09066B",
    fillOpacity: 0.8
  })), _ellipse71 || (_ellipse71 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 92.3575,
    cy: 72.5568,
    rx: 2.63879,
    ry: 2.57293,
    fill: "#09066B",
    fillOpacity: 0.8
  })), _ellipse72 || (_ellipse72 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 110.301,
    cy: 72.5568,
    rx: 2.63879,
    ry: 2.57293,
    fill: "#09066B",
    fillOpacity: 0.8
  })), _ellipse73 || (_ellipse73 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 128.245,
    cy: 72.5568,
    rx: 2.63879,
    ry: 2.57293,
    fill: "#09066B",
    fillOpacity: 0.8
  })), _ellipse74 || (_ellipse74 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 146.189,
    cy: 72.5568,
    rx: 2.63879,
    ry: 2.57293,
    fill: "#09066B",
    fillOpacity: 0.8
  })), _ellipse75 || (_ellipse75 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 164.133,
    cy: 72.5568,
    rx: 2.63879,
    ry: 2.57293,
    fill: "#09066B",
    fillOpacity: 0.8
  })), _ellipse76 || (_ellipse76 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 92.3575,
    cy: 90.0527,
    rx: 2.63879,
    ry: 2.57293,
    fill: "#09066B",
    fillOpacity: 0.8
  })), _ellipse77 || (_ellipse77 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 110.301,
    cy: 90.0527,
    rx: 2.63879,
    ry: 2.57293,
    fill: "#09066B",
    fillOpacity: 0.8
  })), _ellipse78 || (_ellipse78 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 128.245,
    cy: 90.0527,
    rx: 2.63879,
    ry: 2.57293,
    fill: "#09066B",
    fillOpacity: 0.8
  })), _ellipse79 || (_ellipse79 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 146.189,
    cy: 90.0527,
    rx: 2.63879,
    ry: 2.57293,
    fill: "#09066B",
    fillOpacity: 0.8
  })), _ellipse80 || (_ellipse80 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 164.133,
    cy: 90.0527,
    rx: 2.63879,
    ry: 2.57293,
    fill: "#09066B",
    fillOpacity: 0.8
  })), _ellipse81 || (_ellipse81 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 92.3575,
    cy: 107.549,
    rx: 2.63879,
    ry: 2.57293,
    fill: "#09066B",
    fillOpacity: 0.8
  })), _ellipse82 || (_ellipse82 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 110.301,
    cy: 107.549,
    rx: 2.63879,
    ry: 2.57293,
    fill: "#09066B",
    fillOpacity: 0.8
  })), _ellipse83 || (_ellipse83 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 128.245,
    cy: 107.549,
    rx: 2.63879,
    ry: 2.57293,
    fill: "#09066B",
    fillOpacity: 0.8
  })), _ellipse84 || (_ellipse84 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 146.189,
    cy: 107.549,
    rx: 2.63879,
    ry: 2.57293,
    fill: "#09066B",
    fillOpacity: 0.8
  })), _ellipse85 || (_ellipse85 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 164.133,
    cy: 107.549,
    rx: 2.63879,
    ry: 2.57293,
    fill: "#09066B",
    fillOpacity: 0.8
  })), _ellipse86 || (_ellipse86 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 92.3575,
    cy: 125.045,
    rx: 2.63879,
    ry: 2.57293,
    fill: "#09066B",
    fillOpacity: 0.8
  })), _ellipse87 || (_ellipse87 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 110.301,
    cy: 125.045,
    rx: 2.63879,
    ry: 2.57293,
    fill: "#09066B",
    fillOpacity: 0.8
  })), _ellipse88 || (_ellipse88 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 128.245,
    cy: 125.045,
    rx: 2.63879,
    ry: 2.57293,
    fill: "#09066B",
    fillOpacity: 0.8
  })), _ellipse89 || (_ellipse89 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 146.189,
    cy: 125.045,
    rx: 2.63879,
    ry: 2.57293,
    fill: "#09066B",
    fillOpacity: 0.8
  })), _ellipse90 || (_ellipse90 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 164.133,
    cy: 125.045,
    rx: 2.63879,
    ry: 2.57293,
    fill: "#09066B",
    fillOpacity: 0.8
  })), _ellipse91 || (_ellipse91 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 92.3575,
    cy: 142.54,
    rx: 2.63879,
    ry: 2.57293,
    fill: "#09066B",
    fillOpacity: 0.8
  })), _ellipse92 || (_ellipse92 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 110.301,
    cy: 142.54,
    rx: 2.63879,
    ry: 2.57293,
    fill: "#09066B",
    fillOpacity: 0.8
  })), _ellipse93 || (_ellipse93 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 128.245,
    cy: 142.54,
    rx: 2.63879,
    ry: 2.57293,
    fill: "#09066B",
    fillOpacity: 0.8
  })), _ellipse94 || (_ellipse94 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 146.189,
    cy: 142.54,
    rx: 2.63879,
    ry: 2.57293,
    fill: "#09066B",
    fillOpacity: 0.8
  })), _ellipse95 || (_ellipse95 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 164.133,
    cy: 142.54,
    rx: 2.63879,
    ry: 2.57293,
    fill: "#09066B",
    fillOpacity: 0.8
  })), _ellipse96 || (_ellipse96 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 92.3575,
    cy: 160.036,
    rx: 2.63879,
    ry: 2.57293,
    fill: "#09066B",
    fillOpacity: 0.8
  })), _ellipse97 || (_ellipse97 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 110.301,
    cy: 160.036,
    rx: 2.63879,
    ry: 2.57293,
    fill: "#09066B",
    fillOpacity: 0.8
  })), _ellipse98 || (_ellipse98 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 128.245,
    cy: 160.036,
    rx: 2.63879,
    ry: 2.57293,
    fill: "#09066B",
    fillOpacity: 0.8
  })), _ellipse99 || (_ellipse99 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 146.189,
    cy: 160.036,
    rx: 2.63879,
    ry: 2.57293,
    fill: "#09066B",
    fillOpacity: 0.8
  })), _ellipse100 || (_ellipse100 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 164.133,
    cy: 160.036,
    rx: 2.63879,
    ry: 2.57293,
    fill: "#09066B",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots);
export default __webpack_public_path__ + "static/media/dots.efc3872c108cabe57cffab9b2fd096a8.svg";
export { ForwardRef as ReactComponent };